import React from 'react';
import Button from 'src/app/atoms/Button/Button';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import HeadingAndSupportingText from 'src/app/molecules/HeadingAndSupportingText/HeadingAndSupportingText';
import SocialProofBadges from 'src/app/molecules/SocialProofBadges/SocialProofBadges';

const RankedG2 = (): JSX.Element => {
  return (
    <Stack
      gap='spacing-4xl'
      gapSm='spacing-6xl'
      directionSm='column'
    >
      <Grid>
        <Stack
          direction='column'
          align='flex-start'
          columns={11}
          columnsMd={12}
        >
          <Stack
            gap='spacing-4xl'
            direction='column'
            align='flex-start'
          >
            <HeadingAndSupportingText
              heading={{
                text: 'Ranked #1 by G2',
                type: 'heading',
                size: 'xl',
                fontWeight: 'font-weight-semibold',
              }}
              supportingText={{
                type: 'paragraph',
                size: 'xl',
                fontWeight: 'font-weight-regular',
                textAlign: 'left',
                children: (
                  <>
                    With a satisfaction score of 99 out of 100—and a team obsessing over getting that final point.
                    <br />
                    <br />
                    *We know, people <i>love</i> to say this. When we say it?
                  </>
                ),
              }}
            />
          </Stack>
          <Stack>
            <Button
              variant='brand-text-link'
              size='xl'
              href='https://www.g2.com/categories/online-community-management?tab=highest_rated'
            >
              It’s true. 😎
            </Button>
          </Stack>
        </Stack>
        <Stack columns={1} />
      </Grid>
      <SocialProofBadges />
    </Stack>
  );
};

export default RankedG2;
